module.exports = __webpack_public_path__ + "static/main_bg-2d2737163f32285521bd465419128ac1.svg";